import React from "react";

export default function PageNotFoundComponent() {
  return <div>PageNotFoundComponent</div>;
}
